import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import RandomSelectionForm from "./RandomSelectionForm";

export interface State {}

export interface CreateRandomSelectionFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  percentage?: number;
  data?: any;
}

class CreateRandomSelectionForm extends React.Component<
  CreateRandomSelectionFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let newData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = values;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate, percentage, data } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <RandomSelectionForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        percentage={percentage}
        data={data}
      />
    );
  }
}

export default CreateRandomSelectionForm;
